import { atom } from "recoil";
import { IMasterLegalEntity } from "../type/MasterLegalEntityTypeInterface";

export const addStateMasterLegalEntity = atom({
  key: "addStateMasterLegalEntity",
  default: false,
});
export const editStateMasterLegalEntity = atom({
  key: "editStateMasterLegalEntity",
  default: false,
});
export const rowEditMasterLegalEntity = atom<IMasterLegalEntity | undefined>({
  key: "rowEditMasterLegalEntity",
  default: undefined,
});

export const selectedRowsStateMasterLegalEntity = atom<IMasterLegalEntity[]>({
  key: "selectedRowsStateBusinessType",
  default: [],
});

export const masterLegalEntityFilterText = atom({
  key: "masterLegalEntityFilterText",
  default: "",
});

export const masterLegalEntityFetching = atom({
  key: "masterLegalEntityFetching",
  default: true,
});

export const masterLegalEntityRefetching = atom({
  key: "masterLegalEntityRefetching",
  default: true,
});
